import { render, staticRenderFns } from "./RegistrationSertificates.vue?vue&type=template&id=5e3a942f"
import script from "./RegistrationSertificates.vue?vue&type=script&lang=js"
export * from "./RegistrationSertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports